import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { logout } from "../../services/auth.service.js";

import { useSelector } from "react-redux";

const AvatarMenu = (props = {}) => {
  const { open, setOpen, userId } = props;
  const role = useSelector((state) => state.user.role);
  const menuRef = useRef(null);
  const navigate = useNavigate();

  // close on outside click
  useEffect(() => {
    if (!open) return;

    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open, setOpen]);

  if (!open) return null;

  const handleProfile = () => {
    setOpen(false);
    navigate(`/profile/${userId}`);
  };

  const handleMyAccess = () => {
    setOpen(false);
    navigate("/my-access");
  };

  const handleAdmin = () => {
    setOpen(false);
    navigate("/admin");
  };

  const handleSettings = () => {
    setOpen(false);
    navigate("/settings");
  };

  const handleLogout = async () => {
    setOpen(false);
    await logout();
    navigate("/login", { replace: true });
  };

  return (
    <div ref={menuRef} className="avatar-menu">
      <button onClick={handleProfile} className="avatar-menu-item">Profile</button>
      <button onClick={handleMyAccess} className="avatar-menu-item">My Access</button>
      <button onClick={handleSettings} className="avatar-menu-item">Settings</button>
      {role === "admin" && (
        <button onClick={handleAdmin} className="avatar-menu-item">Admin</button>
      )}
      <button onClick={handleLogout} className="avatar-menu-item danger">Logout</button>
    </div>
  );
};

export default AvatarMenu;
